var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{attrs:{"active":_vm.$props.popupActive,"title":'GT Metrix: ' + _vm.$props.prospect_url},on:{"update:active":function($event){return _vm.$set(_vm.$props, "popupActive", $event)}}},[_c('div',{staticClass:"chart-container"},[_vm._v("\n\t\t"+_vm._s(_vm.gtMetrixData)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }